import { RegisterCard } from "../../components/RegisterCard";
import { MediaUploadInput } from "../../components/MediaUploadInput";
import { CircleLoader } from "../../components/CircleLoader";
import { BookOpen, FileText, UploadCloud, Send } from "lucide-react";

export const CAhomework = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  return (
    <div className="w-full max-w-5xl mx-auto p-4 animate-in slide-in-from-bottom-4 duration-700">
      {/* Header section with refined spacing */}
      <div className="mb-8">
        <RegisterCard
          title="Assign Homework"
          details="Detailed instructions and media will be shared with parent/guardian portals instantly."
        />
      </div>

      <div className="bg-white rounded-[2.5rem] border border-slate-100 shadow-2xl shadow-blue-900/5 overflow-hidden">
        <div className="flex flex-col lg:flex-row min-h-[600px]">
          {/* Main Content Area */}
          <form
            onSubmit={onFormSubmit}
            className="flex-1 p-8 sm:p-12 space-y-10 order-2 lg:order-1"
          >
            {/* Assignment Details */}
            <div className="space-y-4">
              <label className="flex items-center gap-2 text-sm font-black text-slate-700 uppercase tracking-widest ml-1">
                <BookOpen size={18} className="text-blue-600" />
                Task Instructions
              </label>
              <div className="relative group">
                <textarea
                  defaultValue={formData["description"]}
                  onChange={(e) => onFormChange("description", e.target.value)}
                  placeholder="Describe the homework tasks, objectives, and deadlines..."
                  className="w-full border-2 border-slate-100 bg-slate-50 p-6 rounded-[1.5rem] min-h-[180px] focus:bg-white focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 outline-none transition-all duration-300 text-slate-700 font-medium placeholder:text-slate-300 resize-none"
                />
              </div>
            </div>

            {/* Media Section with integrated styling */}
            <div className="space-y-4">
              <label className="flex items-center gap-2 text-sm font-black text-slate-700 uppercase tracking-widest ml-1">
                <UploadCloud size={18} className="text-blue-600" />
                Supporting Materials
              </label>
              <div className="bg-slate-50 border-2 border-dashed border-slate-200 rounded-[2rem] p-6 transition-colors hover:border-blue-300 group">
                <MediaUploadInput
                  singleOption={false}
                  onChangeFn={(e: any, type: any) =>
                    onFormChange(
                      type === "video"
                        ? "video"
                        : type === "image"
                          ? "image"
                          : "doc",
                      e && type === "video"
                        ? e.target.files[0]
                        : e && type === "image"
                          ? e.target.files[0]
                          : e && type === "doc"
                            ? e.target.files[0]
                            : "",
                    )
                  }
                  className="w-full flex flex-col items-center justify-center space-y-4"
                />
                <p className="text-[10px] text-center text-slate-400 mt-4 uppercase font-bold tracking-tighter">
                  Accepted formats: Images, Videos, or PDF Documents
                </p>
              </div>
            </div>

            {/* Action Button */}
            <div className="pt-4">
              <button
                type="submit"
                disabled={loading}
                className={`group relative w-full lg:w-max min-w-[240px] h-16 rounded-2xl font-black transition-all duration-500 overflow-hidden shadow-xl
                  ${
                    loading
                      ? "bg-slate-100 cursor-not-allowed"
                      : "bg-slate-900 text-white hover:bg-black hover:-translate-y-1 active:scale-95 shadow-blue-900/20"
                  }
                `}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

                <div className="flex items-center justify-center gap-3 px-10 relative z-10">
                  {loading ? (
                    <CircleLoader />
                  ) : (
                    <>
                      <Send
                        size={20}
                        className="text-blue-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                      />
                      <span className="uppercase tracking-widest text-sm">
                        Post Assignment
                      </span>
                    </>
                  )}
                </div>
              </button>
            </div>
          </form>

          {/* Side Info Panel */}
          <div className="lg:w-96 bg-slate-50/50 border-l border-slate-100 p-10 flex flex-col items-center justify-center text-center order-1 lg:order-2">
            <div className="relative mb-8">
              <div className="absolute inset-0 bg-blue-400 blur-[60px] opacity-10 rounded-full" />
              <img
                src="/img/sticky-note.svg"
                alt="homework icon"
                className="w-48 h-48 relative z-10 drop-shadow-2xl animate-float"
              />
            </div>
            <div className="space-y-2">
              <h5 className="font-black text-slate-800 uppercase tracking-tight">
                Assignment Mode
              </h5>
              <p className="text-sm text-slate-500 font-medium leading-relaxed">
                Adding media helps students visualize the task. Ensure all
                photos are clear before uploading.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
